document.addEventListener('DOMContentLoaded', () => {
    // 1. ハンバーガーメニュー
    const tgl = document.querySelector("#header .tgl");
    const gnav = document.querySelector("#header .gnav");
    
    if (tgl && gnav) {
        tgl.addEventListener('click', function() {
            this.classList.toggle('active');
            // スライドのアニメーションはCSSで制御するのが一般的ですが、JSで簡易的に
            gnav.style.display = (gnav.style.display === 'block') ? 'none' : 'block';
        });
    }

    // 2. スムーススクロール
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href === "#") return;
            
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth' });
                
                // メニューを閉じる
                tgl?.classList.remove('active');
                gnav ? gnav.style.display = 'none' : null;
            }
        });
    });

    // 3. スクロールアニメーション (Intersection Observerを使用)
    // 元のコードより圧倒的に動作が軽くなります
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
            }
        });
    }, { threshold: 0.25 }); // 25%見えたら発火

    document.querySelectorAll('.animation').forEach(el => observer.observe(el));

    // 4. スライダー
    const solutions = document.querySelectorAll("#main .solution");
    if (solutions.length > 0) {
        let currentIndex = 0;
        // スライドの枚数を取得（最初のsolution内のslideの数）
        const slidesCount = solutions[0].querySelectorAll(".slide").length;

        setInterval(() => {
            currentIndex = (currentIndex + 1) % slidesCount;
            solutions.forEach(solution => {
                const slides = solution.querySelectorAll(".slide");
                slides.forEach((slide, idx) => {
                    if (idx === currentIndex) {
                        slide.classList.add('active');
                    } else {
                        slide.classList.remove('active');
                    }
                });
            });
        }, 5000);
    }
});